module.exports = __webpack_public_path__ + "img/插图_加入我们_01@2x.3fd479cb.png";